import React from "react";
import { connect } from "react-redux";

import { doGetAllDrivers, doCreateDriver, doUpdateDriver, doDeleteDriver } from "../stores/thunk";
import { selectAllDrivers } from "../stores/slice";

export default Component => {
  class Container extends React.Component {
    render() {
      return <Component {...this.props} />;
    }
  }
  function mapStateToProps(state) {
    return {
      isFetching: state.driver.isFetching,
      status: state.driver.status,
      metadata: state.driver.metadata,
      drivers: selectAllDrivers(state),
    };
  }

  return connect(mapStateToProps, {
    doGetAllDrivers,
    doCreateDriver,
    doUpdateDriver,
    doDeleteDriver,
  })(Container);
};
